const actions = {
	GET_MULTIPLE_ANSWER: 'GET_MULTIPLE_ANSWER',
	GET_MULTIPLE_ANSWER_SUCCESS: 'GET_MULTIPLE_ANSWER_SUCCESS',

	CREATE_NEW_MULTIPLE_ANSWER: 'CREATE_NEW_MULTIPLE_ANSWER',
	CREATE_NEW_MULTIPLE_ANSWER_SUCCESS: 'CREATE_NEW_MULTIPLE_ANSWER_SUCCESS',

	DELETE_MULTIPLE_ANSWER: 'DELETE_MULTIPLE_ANSWER',
	DELETE_MULTIPLE_ANSWER_SUCCESS: 'DELETE_MULTIPLE_ANSWER_SUCCESS',

	GET_MULTIPLE_ANSWER_DETAIL: 'GET_MULTIPLE_ANSWER_DETAIL',
	GET_MULTIPLE_ANSWER_DETAIL_SUCCESS: 'GET_MULTIPLE_ANSWER_DETAIL_SUCCESS',

	UPDATE_MULTIPLE_ANSWER_DETAIL: 'UPDATE_MULTIPLE_ANSWER_DETAIL',
	UPDATE_MULTIPLE_ANSWER_DETAIL_SUCCESS: 'UPDATE_MULTIPLE_ANSWER_DETAIL_SUCCESS',

	READING_LOADING_FALSE: 'READING_LOADING_FALSE',
	//#region CRUD

	getMultipleAnswer: (model) => ({
		type: actions.GET_MULTIPLE_ANSWER,
		payload: { model },
	}),

	getMultipleAnswerDetail: (id) => ({
		type: actions.GET_MULTIPLE_ANSWER_DETAIL,
		payload: { id },
	}),

	// createQuesReadAloud: (body, cbSuccess, cbError) => ({
	// 	type: actions.CREATE_NEW_MULTIPLE_ANSWER,
	// 	payload: { body },
	// 	cbSuccess,
	// 	cbError,
	// }),

	// updateReadAloudDetail: (model, cbSuccess, cbError) => ({
	// 	type: actions.UPDATE_MULTIPLE_ANSWER_DETAIL,
	// 	payload: { model },
	// 	cbSuccess,
	// 	cbError,
	// }),

	// deleteReadAloud: (id, cbSuccess, cbError) => ({
	// 	type: actions.DELETE_MULTIPLE_ANSWER,
	// 	payload: { id },
	// 	cbSuccess,
	// 	cbError,
	// }),
};

export default actions;
